module.exports = __webpack_public_path__ + "img/icon-start-over.89562b93.svg";